import Chart from 'react-google-charts';
import { ChartDataLoaded } from '@g17eco/types/insight-custom-dashboard';
import { getChartOptions, toChartProps } from '@routes/summary/insights/utils/chartStyles';
import { chartTooltipOptions, ChartType } from '@routes/summary/insights/utils/constants';
import { getVAxisTitle, hasChartDataRows } from './multi-utrs-chart/utils';
import { getChartMaxValue } from '@utils/charts';
import { BaseChartComponentProps, BaseHistoricalUtr, ChartDataProps } from '../types';
import { useChartData } from './useChartData';

type Props<T extends BaseHistoricalUtr> = BaseChartComponentProps<T> & {
  getChartData: (props: ChartDataProps<T>) => Promise<ChartDataLoaded>;
};

export const LineChart = <T extends BaseHistoricalUtr>(props: Props<T>) => {
  const { getChartData, calculation, unitText, utrsData, overrideOptions } = props;
  const data = useChartData(getChartData, props);

  if (!calculation || !data || !hasChartDataRows(data.chartData)) {
    return null;
  }

  const vAxisTitle = getVAxisTitle({ unitText, calculation, utrsData });
  const vAxisMaxValue = getChartMaxValue(data.chartData);

  return (
    <div className='w-100 h-100' data-testid='line-chart'>
      <Chart
        chartType={ChartType.LineChart}
        data={data.chartData}
        width={'100%'}
        height={'100%'}
        options={{
          tooltip: chartTooltipOptions,
          ...(overrideOptions ??
            getChartOptions({
              chartType: ChartType.LineChart,
              vAxisTitle,
              vAxisMaxValue,
              chartProps: toChartProps(props),
            })),
        }}
      />
    </div>
  );
};
